import { render } from "./ConfirmNewJob.vue?vue&type=template&id=ef379668"
import script from "./ConfirmNewJob.vue?vue&type=script&lang=js"
export * from "./ConfirmNewJob.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__